import { savingsTracker } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const GetSavingsTracker = gql`
  query GetSavingsTracker($id: ID!) {
    accountR2(id: $id) {
      id
      ... on InternalSavingsAccount {
        apy
        savingsTracker {
          ...savingsTracker
        }
      }
    }
  }
  ${savingsTracker}
`;

export default GetSavingsTracker;
